"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Barcodes;
exports.useStyles = void 0;

var React = _interopRequireWildcard(require("react"));

var _ImagePreview = _interopRequireDefault(require("../images/ImagePreview"));

var _usePkpass2 = require("../usePkpass");

var _barcode = require("../helpers/barcode");

var _Barcode = _interopRequireDefault(require("./Barcode"));

var _types = require("../../../../types");

var _reactJss = require("react-jss");

var _Theme = require("../../Theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var useStyles = (0, _reactJss.createUseStyles)({
  root: {
    bottom: function bottom(_ref) {
      var pass = _ref.pass,
          theme = _ref.theme;
      var barcodeTypeValue = pass.barcodes && pass.barcodes[0] && pass.barcodes[0].format;
      var bottomPosition = 12;

      if (_barcode.barcodeTypes[barcodeTypeValue] && !_barcode.barcodeTypes[barcodeTypeValue].isSquared) {
        bottomPosition = 30;
      }

      return bottomPosition * theme.scale;
    },
    position: 'absolute',
    textAlign: 'center',
    width: '100%'
  },
  footerImageContainer: {
    bottom: '100%',
    left: function left(_ref2) {
      var theme = _ref2.theme;
      return theme.scale * 10;
    },
    position: 'absolute',
    right: function right(_ref3) {
      var theme = _ref3.theme;
      return theme.scale * 10;
    }
  },
  barcodeContainer: {
    borderRadius: function borderRadius(_ref4) {
      var theme = _ref4.theme;
      return theme.scale * 5;
    },
    backgroundColor: 'white',
    display: 'inline-block',
    maxWidth: function maxWidth(_ref5) {
      var theme = _ref5.theme;
      return theme.scale * 250;
    },
    paddingBottom: function paddingBottom(_ref6) {
      var theme = _ref6.theme;
      return theme.scale * 5;
    },
    paddingLeft: function paddingLeft(_ref7) {
      var theme = _ref7.theme;
      return theme.scale * 10;
    },
    paddingRight: function paddingRight(_ref8) {
      var theme = _ref8.theme;
      return theme.scale * 10;
    },
    paddingTop: function paddingTop(_ref9) {
      var theme = _ref9.theme;
      return theme.scale * 10;
    },
    position: 'relative',
    '&:hover': {
      cursor: function cursor(_ref10) {
        var clickable = _ref10.clickable;
        return clickable ? 'pointer' : undefined;
      },
      opacity: function opacity(_ref11) {
        var clickable = _ref11.clickable;
        return clickable ? 0.7 : undefined;
      }
    }
  },
  altTextContainer: {
    color: 'black',
    paddingTop: function paddingTop(_ref12) {
      var theme = _ref12.theme;
      return theme.scale * 5;
    },
    fontSize: function fontSize(_ref13) {
      var theme = _ref13.theme;
      return theme.scale * 10;
    },
    margin: 'auto',
    maxWidth: function maxWidth(_ref14) {
      var theme = _ref14.theme;
      return theme.scale * 130;
    },
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
});
exports.useStyles = useStyles;

function Barcodes() {
  var _usePkpass = (0, _usePkpass2.usePkpass)(),
      pass = _usePkpass.pass,
      passStyle = _usePkpass.passStyle,
      language = _usePkpass.language,
      scanDisabled = _usePkpass.scanDisabled,
      onBarcodeClick = _usePkpass.onBarcodeClick;

  var theme = (0, _Theme.useTheme)();
  var classes = useStyles({
    pass: pass,
    theme: theme,
    clickable: !!onBarcodeClick
  });

  if (!pass.barcodes || !pass.barcodes[0]) {
    return /*#__PURE__*/React.createElement("div", null);
  }

  var barcodeTypeValue = pass.barcodes[0].format;
  var barcodes = pass.barcodes;
  var altText = barcodes[0].altText;
  var value = barcodes[0].message;

  if (value && typeof value != 'string') {
    value = value[language];
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, passStyle === 'boardingPass' && /*#__PURE__*/React.createElement("div", {
    className: classes.footerImageContainer
  }, /*#__PURE__*/React.createElement(_ImagePreview.default, {
    imageType: _types.ImageTypes.footer
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.barcodeContainer,
    onClick: onBarcodeClick
  }, value && _barcode.barcodeTypesValues && /*#__PURE__*/React.createElement(_Barcode.default, {
    value: value,
    barcodeType: barcodeTypeValue,
    disabled: scanDisabled
  }), /*#__PURE__*/React.createElement("div", {
    key: "alt-text",
    className: classes.altTextContainer
  }, altText)));
}
//# sourceMappingURL=Barcodes.js.map